import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const me = await api("/auth/me");
      setUser(me);
    } catch {
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (identifier, password) => {
    const res = await api("/auth/login", { method: "POST", auth: false, body: { identifier, password } });
    setToken(res.access_token);
    setUser(res.user);
    return res.user;
  };

  const signup = async (payload) => {
    const res = await api("/auth/signup", { method: "POST", auth: false, body: payload });
    setToken(res.access_token);
    setUser(res.user);
    return res.user;
  };

  const logout = () => {
    setToken(null);
    setUser(null);
  };

  const loginWithToken = (token, userObj) => {
    setToken(token);
    setUser(userObj);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, signup, logout, loginWithToken, refresh, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
